import { useState } from "preact/hooks";
import type { DashboardViewModel } from "../app/dashboardViewModel";
import { isMacroMicro } from "../app/grindFormat";
import { Stars } from "./Stars";
import { Stepper } from "./Stepper";
import { TasteControl } from "./TasteControl";

export const LOG_FORM_ID = "log-form";
export const TIME_INPUT_ID = "time-input";

export function LogShotForm({ vm }: { vm: DashboardViewModel }) {
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      setError(await vm.logShot());
    } finally {
      setSaving(false);
    }
  };

  return (
    <section class="card" id={LOG_FORM_ID} aria-label="Log shot" style={{ scrollMarginTop: "12px" }}>
      <h2 class="section-title">Log shot</h2>
      <div class="form-grid">
        <Stepper label="Time" unit="s" sig={vm.timeText} placeholder="—" inputId={TIME_INPUT_ID}
                 onStep={(d) => vm.stepField("time", d)} onBlur={() => vm.normalizeField("time")} />
        <Stepper label="Grind" unit="dial" sig={vm.grindText} text={isMacroMicro(vm.selectedGrinder.value)}
                 onStep={(d) => vm.stepField("grind", d)} onBlur={() => vm.normalizeField("grind")} />
        <Stepper label="Dose" unit="g" sig={vm.doseText}
                 onStep={(d) => vm.stepField("dose", d)} onBlur={() => vm.normalizeField("dose")} />
        <Stepper label="Yield" unit="g" sig={vm.yieldText}
                 onStep={(d) => vm.stepField("yield", d)} onBlur={() => vm.normalizeField("yield")} />
      </div>
      <div class="hint" style={{ marginTop: 6 }}>Time is from pump start, including any pre-infusion.</div>
      {vm.timeWarning.value && <div class="warn" style={{ marginTop: 6 }}>{vm.timeWarning.value}</div>}
      {vm.grindWarning.value && <div class="warn" style={{ marginTop: 6 }}>{vm.grindWarning.value}</div>}

      <div style={{ marginTop: 10 }}><Stars value={vm.rating.value} onChange={(v) => (vm.rating.value = v)} /></div>
      <div style={{ marginTop: 6 }}><TasteControl value={vm.taste.value} onToggle={(t) => vm.toggleTaste(t)} /></div>

      {error && <div class="error" style={{ marginTop: 8 }}>{error}</div>}
      <button class="primary" style={{ marginTop: 14 }} onClick={() => void save()} disabled={saving}>Save shot</button>
    </section>
  );
}
